import KeywordsCard from './widgets/KeywordsCard'
import DbStatsCard from './widgets/DbStatsCard'
import AgentsProgressGrid from './widgets/AgentsProgressGrid'
import SummarizerProgressCard from './widgets/SummarizerProgressCard'
import FinalAnswerCard from './widgets/FinalAnswerCard'
import ResearchSummaryCard from './widgets/ResearchSummaryCard'
import ComprehensiveAnswerCard from './widgets/ComprehensiveAnswerCard'

export default function StreamWidgets({ data, loading, wsStatus }) {
  // Debug logging to see what data structure we're receiving
  console.log('🌊 StreamWidgets rendered with:', {
    data,
    loading,
    wsStatus,
    dataKeys: Object.keys(data),
    hasDbStats: !!data.db_stats,
    dbStatsContent: data.db_stats
  })
  
  // Helper function to check if all agents are completed
  const checkAgentsCompleted = (agentProgress) => {
    if (!agentProgress || typeof agentProgress !== 'object') return false
    const agents = Object.values(agentProgress)
    return agents.length > 0 && agents.every(agent => agent.status === 'completed')
  }
  
  const showConnectionStatus = wsStatus !== 'connected' && loading

  return (
    <div className="space-y-2">
      {/* Connection Status */}
      {showConnectionStatus && (
        <div className="alert alert-warning">
          <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
          <span>
            {wsStatus === 'reconnecting' ? 'Reconnecting to server...' : 'Connecting...'}
          </span>
        </div>
      )}

      {/* Widget Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Keywords */}
        {(data.keywords || loading) && (
          <div className="col-span-1">
            <KeywordsCard data={data.keywords} loading={loading && !data.keywords} />
          </div>
        )}

        {/* DB Stats */}
        {(data.db_stats || (loading && data.keywords)) && (
          <div className="col-span-1">
            <DbStatsCard data={data.db_stats} loading={loading && !data.db_stats} />
          </div>
        )}

        {/* Agents Progress */}
        {(data.agent_progress || (loading && data.db_stats)) && (
          <div className="col-span-1 md:col-span-2">
            <AgentsProgressGrid data={data.agent_progress} loading={loading && !data.agent_progress} />
          </div>
        )}

        {/* Summarizer Progress - hide when research is complete */}
        {!data.final_answer && (data.summarizer || (loading && data.agent_progress && checkAgentsCompleted(data.agent_progress))) && (
          <div className="col-span-1 md:col-span-2">
            <SummarizerProgressCard data={data.summarizer} loading={loading && !data.summarizer} />
          </div>
        )}

        {/* Summary Stats */}
        {data.summary_stats && (
          <div className="col-span-1 md:col-span-2">
            <ResearchSummaryCard data={data.summary_stats} loading={false} />
          </div>
        )}

        {/* Final Answer */}
        {data.final_answer && (
          <div className="col-span-1 md:col-span-2">
            <ComprehensiveAnswerCard data={data.final_answer} loading={false} />
          </div>
        )}
      </div>

      {/* Empty State */}
      {!loading && Object.keys(data).length === 0 && (
        <div className="text-center py-2">
          <p className="text-base-content/60">
            Enter a research question to begin
          </p>
        </div>
      )}
    </div>
  )
}